const SAFE_DATA_IMAGE_REGEX = /^data:image\/(?:png|jpe?g|gif|webp|bmp|avif);base64,/i;

/**
 * Accept only URL forms that are safe to inject into link/image attributes.
 * Explicitly blocks protocol-relative paths (//...) and untrusted schemes.
 */
export function isSafeAttachmentUrl(url: string): boolean {
    const normalizedUrl = url.trim();
    if (!normalizedUrl) return false;
    if (SAFE_DATA_IMAGE_REGEX.test(normalizedUrl)) return true;
    if (normalizedUrl.startsWith('blob:')) return true;
    if (normalizedUrl.startsWith('/')) return !normalizedUrl.startsWith('//');

    if (!/^https?:\/\//i.test(normalizedUrl)) return false;

    try {
        const parsed = new URL(normalizedUrl);
        return parsed.protocol === 'http:' || parsed.protocol === 'https:';
    } catch {
        return false;
    }
}

export function getExtension(urlStr: string): string {
    try {
        const pathname = new URL(urlStr).pathname;
        const filename = pathname.split('/').pop() || '';
        const dotIndex = filename.lastIndexOf('.');
        return dotIndex !== -1 ? filename.substring(dotIndex).toLowerCase() : '';
    } catch {
        const cleanPath = urlStr.split('?')[0].split('#')[0];
        const filename = cleanPath.split('/').pop() || '';
        const dotIndex = filename.lastIndexOf('.');
        return dotIndex !== -1 ? filename.substring(dotIndex).toLowerCase() : '';
    }
}

